<div class="content">
	<div class="card">
		<div class="image"><img alt="CareConnect Into.Care" src="assets/images/logo_CC-intocare_HOR.png" /></div>
		<p class="message">
			{{ noPermissionsLabel | translate }}
		</p>
		<ui-button class="btn-action" data-test="no-permissions-close" (click)="navigate()">{{
			buttonLabel() | translate
		}}</ui-button>
	</div>
</div>

<a class="contact" href="{{ 'support.contactUrl' | translate }}" target="_blank">
	<i class="fa fa-envelope"></i>{{ "auth.contact" | translate }}
</a>
